import type { DataVizBaseProps } from 'common/components/DataViz/DataViz.types'
import { ChunkLine, ChunkLineProps } from './ChunkLine'
import { ChunkLabel } from './ChunkLabel'

export interface ChunkSetItem extends Pick<ChunkLineProps, 'start_time' | 'end_time' | 'status'> {
  data: Record<string, unknown>[];
}

export interface ChunkLinesProps extends Pick<ChunkLineProps, 'axes' | 'colors'>,
  Pick<DataVizBaseProps, 'selected' | 'checkIfSelected' | 'grouping_key'> {
  chunk_lines?: ChunkSetItem[];
  chunk_segments?: ChunkSetItem[];
}

export const ChunkLines = ({ axes, chunk_lines = [], colors, selected, checkIfSelected, grouping_key }: ChunkLinesProps): JSX.Element => (
  <g className='demo-chunk-lines'>
    {chunk_lines.map(chunk => (
      <ChunkLine
        key={`${chunk.start_time}-${chunk.end_time}`}
        axes={axes}
        data={chunk.data}
        start_time={chunk.start_time}
        end_time={chunk.end_time}
        status={chunk.status}
        colors={colors}
        selected={selected}
        checkIfSelected={checkIfSelected}
        grouping_key={grouping_key}
      />
    ))}
  </g>
)

export const ChunkLabels = ({ axes, chunk_segments = [] }: ChunkLinesProps): JSX.Element => (
  <>
    {chunk_segments.map(segment => (
      <ChunkLabel
        key={`${segment.start_time}-${segment.end_time}`}
        axes={axes}
        start_time={segment.start_time}
        end_time={segment.end_time}
        status={segment.status}
      />
    ))}
  </>
)
